 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + "3e49a5ad" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-066b112e":1,"chunk-04ebca4f":1,"chunk-0a21e0a3":1,"chunk-0ba85fad":1,"chunk-0bc63e75":1,"chunk-0e18452e":1,"chunk-18d02569":1,"chunk-19d463ff":1,"chunk-1b2aad36":1,"chunk-21b1cee0":1,"chunk-234da87f":1,"chunk-23f5ca24":1,"chunk-29d0e51b":1,"chunk-669f4f37":1,"chunk-b6fff178":1,"chunk-f7786c3e":1,"chunk-0c7063d0":1,"chunk-364ca294":1,"chunk-ee456d98":1,"chunk-0d65ec9e":1,"chunk-1ac04496":1,"chunk-611c8cfe":1,"chunk-62efe096":1,"chunk-9d5efe02":1,"chunk-786fce1e":1,"chunk-09d9d755":1,"chunk-3f91a488":1,"chunk-4f110e43":1,"chunk-579ecd79":1,"chunk-6a0c54c5":1,"chunk-a9cf933a":1,"chunk-82f66c5e":1,"chunk-2d4e83b4":1,"chunk-2d58b804":1,"chunk-31f7eaa0":1,"chunk-0fcc23a2":1,"chunk-24b5b821":1,"chunk-4dc37ae0":1,"chunk-3a3c02ae":1,"chunk-3c7aa6b2":1,"chunk-3e73ab18":1,"chunk-47e68f20":1,"chunk-481ff93d":1,"chunk-4c8ffd3d":1,"chunk-507974c6":1,"chunk-54a68283":1,"chunk-54c070b2":1,"chunk-57f617d2":1,"chunk-5ab094bc":1,"chunk-5b772990":1,"chunk-5fae72d6":1,"chunk-11f6e740":1,"chunk-2409ef65":1,"chunk-434785a6":1,"chunk-51d19422":1,"chunk-64c88ef6":1,"chunk-7296b32f":1,"chunk-108a5a58":1,"chunk-686434b4":1,"chunk-69f091f1":1,"chunk-75bfb48a":1,"chunk-7fad4442":1,"chunk-7fccf22e":1,"chunk-8187a8e2":1,"chunk-82ed4b50":1,"chunk-98cf27ca":1,"chunk-a15f0988":1,"chunk-a240b518":1,"chunk-b3884622":1,"chunk-d0b37762":1,"chunk-e05a98ca":1,"chunk-eedd579c":1,"chunk-f38fa632":1,"chunk-f7b6b740":1,"chunk-f8e58936":1,"chunk-23a4ccfc":1,"chunk-b8fa5f9a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-023fb868":"31d6cfe0","chunk-066b112e":"3f89b331","chunk-04ebca4f":"81c7bc06","chunk-0a21e0a3":"4c206f7b","chunk-0ba85fad":"3e15804f","chunk-0bc63e75":"e2f749fe","chunk-0c7b2c68":"31d6cfe0","chunk-0e18452e":"ae4b4fe9","chunk-18d02569":"00070bb4","chunk-19d463ff":"70d243d9","chunk-1b2aad36":"bd011eb2","chunk-21b1cee0":"e6cb2352","chunk-234da87f":"3fdb2255","chunk-23f5ca24":"17626e31","chunk-29d0e51b":"7806db4f","chunk-2d0c510d":"31d6cfe0","chunk-669f4f37":"497c1db7","chunk-b6fff178":"fd51c038","chunk-f7786c3e":"1f5e40a2","chunk-619d7aac":"31d6cfe0","chunk-37688b16":"31d6cfe0","chunk-0c7063d0":"128571f5","chunk-364ca294":"83323cfa","chunk-ee456d98":"c150c158","chunk-2d0b2b47":"31d6cfe0","chunk-0d65ec9e":"b8e12d79","chunk-1ac04496":"b0e3920d","chunk-611c8cfe":"ff4fafda","chunk-62efe096":"dd75c395","chunk-9d5efe02":"585b7bc6","chunk-786fce1e":"edec199a","chunk-09d9d755":"8d0bb325","chunk-3f91a488":"6046294d","chunk-4f110e43":"0384955e","chunk-579ecd79":"fe97b3da","chunk-6a0c54c5":"e335f3de","chunk-a9cf933a":"5b57db5f","chunk-82f66c5e":"1de58259","chunk-2d0c8206":"31d6cfe0","chunk-2d0e9702":"31d6cfe0","chunk-2d0e991a":"31d6cfe0","chunk-2d0f028e":"31d6cfe0","chunk-2d20e788":"31d6cfe0","chunk-2d2160f1":"31d6cfe0","chunk-2d229afb":"31d6cfe0","chunk-2d4e83b4":"f71682ce","chunk-2d58b804":"e3a95052","chunk-31f7eaa0":"2a306316","chunk-0fcc23a2":"c1fff73b","chunk-24b5b821":"b5b29a79","chunk-4dc37ae0":"4ff98609","chunk-3a3c02ae":"2d4facca","chunk-3c7aa6b2":"884ed30c","chunk-3e73ab18":"e3a95052","chunk-4463fdfe":"31d6cfe0","chunk-47e68f20":"0fb5ef4a","chunk-481ff93d":"6a399009","chunk-4c8ffd3d":"2f50a487","chunk-507974c6":"8ca1fb2b","chunk-54a68283":"d50f741e","chunk-2d0ae9a7":"31d6cfe0","chunk-54c070b2":"6d9235ab","chunk-57f617d2":"3e15804f","chunk-5ab094bc":"200f59b4","chunk-5b772990":"85d9b216","chunk-5fae72d6":"413c7d02","chunk-11f6e740":"676d619d","chunk-2409ef65":"31c9adcd","chunk-434785a6":"c346668a","chunk-51d19422":"157cf6fd","chunk-64c88ef6":"284eb59a","chunk-7296b32f":"ed515cbe","chunk-108a5a58":"42ea7477","chunk-686434b4":"a146c01a","chunk-69f091f1":"fadc5cfe","chunk-75bfb48a":"e3a95052","chunk-7fad4442":"e6cb2352","chunk-7fccf22e":"a9f81cf9","chunk-8187a8e2":"7a9f9da5","chunk-82ed4b50":"9f47403a","chunk-98cf27ca":"92d24154","chunk-a15f0988":"fadb88c8","chunk-a240b518":"772bb5b3","chunk-b3884622":"74187da2","chunk-cf3b0bda":"31d6cfe0","chunk-d0b37762":"37387831","chunk-e05a98ca":"d2f3e35c","chunk-eedd579c":"8e9de4e5","chunk-f38fa632":"0408d864","chunk-f7b6b740":"19048649","chunk-f8e58936":"fba66d09","chunk-23a4ccfc":"28dfb3bd","chunk-b8fa5f9a":"9ade32d0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cdnstatic.gamekee.com/wiki/4.0/pc/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["a949","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
